import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiAuthenticationSilencedError } from '@/core/error/transport/customErrors/tmApiAuthenticationSilencedError'

export const apiAuthenticationSilencedErrorRule: CustomErrorRule = {
  subCodes: ['auth.required.no_error'],
  klass: TmApiAuthenticationSilencedError,
}
